import { CartProductType } from '../../../../_context/order-flow-context'

import type { AnnualProgramPriceHighlight } from '@/app/[locale]/order/_utils/price-calculation.utils'


/**
 * Localized highlight line for annual-program pricing states (template checkout).
 */
export function annualProgramHighlightMessage(h: AnnualProgramPriceHighlight): string {
	const nb = '\u00a0'
	switch (h.type) {
		case 'NO_PAYMENT':
			return `V${nb}rámci Vášho programu ${h.programName} je možné objednať sa online bez platby.`
		case 'DISCOUNT_10':
			return `V${nb}rámci Vášho programu ${h.programName} je možné objednať sa online s${nb}10% zľavou.`
		case 'UNABLE_TO_CALCULATE':
			return `V${nb}rámci Vášho programu ${h.programName} je možné sa objednať cez Klientske centrum alebo s${nb}úhradou.`
		default: {
			const _exhaustive: never = h
			void _exhaustive
			return ''
		}
	}
}

/**
 * Insurance block is shown for all product types except promotion and credit program
 * (legacy `canShowInsurance()` parity).
 */
export function canShowInsurance(type: CartProductType): boolean {
	switch (type) {
		case CartProductType.PROMOTION:
		case CartProductType.CREDIT_PROGRAM:
			return false
		default:
			return true
	}
}
